import { Button } from '@/components/v4';
import { DownloadIcon } from '@chakra-ui/icons';

export default function ExportCSVButton({
    options: { columns, data, exportCsv, titleName },
}) {
    const handleExportCsv = () => {
        exportCsv(columns, data, titleName);
    };
    return (
        <Button leftIcon={<DownloadIcon />} onClick={handleExportCsv}>
            Export CSV
        </Button>
    );
}
